import React, { useEffect } from "react";
import { Container, Typography, Box, Divider } from "@mui/material";

const PrivacyPolicy = () => {
  useEffect(() => {
    document.title = "Privacy Policy";
  }, []);

  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Box>
        <Typography variant="h4" fontWeight="bold" gutterBottom color="primary">
          Privacy Policy
        </Typography>
        <Typography variant="caption" color="text.secondary" gutterBottom>
          Last Updated: April 21, 2025
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Typography paragraph>
          CakeyHand is committed to protecting your privacy. This policy
          outlines how we collect, use, and protect your personal information.
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 4 }}>
          1. Information We Collect
        </Typography>
        <Typography paragraph>
          We collect information such as your name, email, phone number,
          address, order details, and communication preferences when you place
          an order or interact with us.
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 4 }}>
          2. Use of Information
        </Typography>
        <Typography paragraph>
          Your information is used for processing orders, communicating with
          you, and improving our products and services.
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 4 }}>
          3. Sharing of Information
        </Typography>
        <Typography paragraph>
          We do not sell or share your personal information with third parties,
          except for service providers who help fulfill your order (e.g.,
          delivery platforms, payment processors).
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 4 }}>
          4. Data Retention
        </Typography>
        <Typography paragraph>
          We retain order and contact information for legal and business
          purposes, such as reordering and customer service.
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 4 }}>
          5. Cookies and Tracking
        </Typography>
        <Typography paragraph>
          Our website may use cookies and tracking tools to improve your
          browsing experience. You can manage these through your browser
          settings.
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 4 }}>
          6. Security Measures
        </Typography>
        <Typography paragraph>
          We use reasonable technical and organizational measures to safeguard
          your personal data.
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 4 }}>
          7. Children's Privacy
        </Typography>
        <Typography paragraph>
          Our services are not directed at children under 13. We do not
          knowingly collect information from minors.
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 4 }}>
          8. Your Rights
        </Typography>
        <Typography paragraph>
          You may request access to, correction of, or deletion of your personal
          information by contacting us.
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 4 }}>
          9. Changes to This Policy
        </Typography>
        <Typography paragraph>
          This policy may be updated periodically. Continued use of our services
          indicates your acceptance of the updated policy.
        </Typography>

        <Divider sx={{ my: 4 }} />

        <Typography variant="body2" color="text.secondary">
          For any questions about our Privacy Policy, please contact us at
          contact@cakeyhand.com.
        </Typography>
      </Box>
    </Container>
  );
};

export default PrivacyPolicy;
